import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SubregionAssignment } from '../loanofficerregionreference.model';
import { SubregionService } from '../subregions/subregions.service';

@Component({
    selector: 'app-subregion-edit',
    templateUrl: './subregion-edit.component.html',
    styleUrls: ['./subregion-edit.component.css']
})
export class SubregionEditComponent implements OnInit {
    public editForm: FormGroup;

    constructor(public dialogRef: MatDialogRef<SubregionEditComponent>,
        @Inject(MAT_DIALOG_DATA) public subregionAssignment: SubregionAssignment, public dialog: MatDialog, public fb: FormBuilder,
        private subregionService: SubregionService) {
        this.createForm();
    }

    ngOnInit() {
        this.editForm.controls.subregionAssignmentControl.setValue(this.subregionAssignment.city);
    }

    createForm() {
        this.editForm = this.fb.group({
            subregionAssignmentControl: ['', [Validators.required, Validators.maxLength(255)]]
        })
    }

    async saveSubregionAssignment() {
        if (!this.editForm.valid) {
            return;
        }
        const formModel = this.editForm.value;
        const updateSubregionAssignment: SubregionAssignment = this.subregionAssignment;
        updateSubregionAssignment.city = formModel.subregionAssignmentControl as string;

        await this.subregionService.updateSubregionAssignment(updateSubregionAssignment);
        this.dialogRef.close(updateSubregionAssignment);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregion-edit/subregion-edit.component.ts